import React from 'react';

import { Users, Key, Settings, AlertTriangle, UserCog, Crown, Building, Briefcase, FileCheck, ShieldCheck, Zap } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

// Couleurs et icônes pour les rôles système
export const ROLE_CONFIG = {
  super_admin: { 
    color: '#DC2626', 
    bgColor: 'bg-red-100', 
    icon: Crown, 
    label: 'Super Admin',
    description: 'Accès complet à toutes les fonctionnalités'
  },
  admin: { 
    color: '#EA580C', 
    bgColor: 'bg-orange-100', 
    icon: ShieldCheck, 
    label: 'Administrateur',
    description: 'Gestion des utilisateurs et paramètres'
  },
  cooper: { 
    color: '#7C3AED', 
    bgColor: 'bg-purple-100', 
    icon: Building, 
    label: "COOPER'S",
    description: 'Membre du réseau COOPER\'S'
  },
  expert: { 
    color: '#0EA5E9', 
    bgColor: 'bg-sky-100', 
    icon: Briefcase, 
    label: 'Expert',
    description: 'Expert conseil du réseau'
  },
  member: { 
    color: '#10B981', 
    bgColor: 'bg-green-100', 
    icon: Users, 
    label: 'Membre',
    description: 'Membre standard'
  },
  beneficiaire_pro: { 
    color: '#6B7280', 
    bgColor: 'bg-gray-100', 
    icon: UserCog, 
    label: 'Bénéficiaire Pro',
    description: 'Bénéficiaire professionnel'
  }
};

// Catégories de permissions avec icônes
export const PERMISSION_CATEGORIES = {
  members: { icon: Users, label: 'Membres', color: 'text-green-600' },
  coopers: { icon: Building, label: "COOPER'S", color: 'text-purple-600' },
  experts: { icon: Briefcase, label: 'Experts', color: 'text-sky-600' },
  subscriptions: { icon: Key, label: 'Abonnements', color: 'text-amber-600' },
  payments: { icon: Zap, label: 'Paiements', color: 'text-emerald-600' },
  documents: { icon: FileCheck, label: 'Documents', color: 'text-blue-600' },
  damages: { icon: AlertTriangle, label: 'Dommages', color: 'text-red-600' },
  agenda: { icon: Settings, label: 'Agenda', color: 'text-indigo-600' },
  admin: { icon: ShieldCheck, label: 'Administration', color: 'text-orange-600' },
  superadmin: { icon: Crown, label: 'Super Admin', color: 'text-red-600' }
};

// Menus du tableau de bord administrateur proposés aux rôles personnalisés.
export const ADMIN_MENUS = [
  { value: 'simulateur', label: 'Garantie RCDS-BATICO' },
  { value: 'simulateur-dos-v12', label: 'DOS-DOMIUM' },
  { value: 'suivi-dos-domium', label: 'Suivi DOS DOMIUM' },
  { value: 'ccmi-cockpit', label: 'Cockpit CCMI' },
  { value: 'vefa-tunnel', label: 'VEFA — Programme immobilier' },
  { value: 'declaration-dommage', label: 'Déclaration Dommage' },
  { value: 'gestion', label: 'Gestion Complète' },
  { value: 'statistiques', label: 'Statistiques par Période' },
  { value: 'ftpe-stats', label: 'Tableau de bord FTPE' },
  { value: 'messagerie', label: 'Messagerie' },
  { value: 'gestion-membres-cooper', label: "Gestion Membres/COOPER'S" },
  { value: 'mes-membres-admin', label: 'Mes Membres' },
  { value: 'achats-attente', label: 'Achats en attente' },
  { value: 'coopers', label: "COOPER'S" },
  { value: 'adhesions', label: 'Gestion des Adhésions' },
  { value: 'recherche', label: 'Recherche Unifiée' },
  { value: 'experts-validation', label: "Validation COOPER'S Advisors" },
  { value: 'souscriptions-validation', label: 'Validation Paiements' },
  { value: 'sepa-rcd', label: 'Mandats SEPA/CB' },
  { value: 'virements-ess', label: 'Factures & Reçus ESS' },
  { value: 'souscriptions-liste', label: 'Toutes Souscriptions' },
  { value: 'suivi-signatures', label: 'Suivi des signatures' },
  { value: 'videos', label: 'Vidéos' },
  { value: 'territoires', label: 'Territoires' },
  { value: 'config', label: 'Configuration' },
];
